export default "__VITE_ASSET__3e150bb7__"